module.exports = "pegasus/assets/blocks/column-7-theme6.png";